<div [class]="footerClass" [class.stack-on-mobile]="stackOnMobile">
  @if (useCompactStyle) {
    @if (showSecondary) {
      <button
        type="button"
        class="link-btn"
        [class.desktop-only]="secondaryDesktopOnly"
        (click)="secondaryClick.emit()"
        [disabled]="secondaryDisabled"
      >
        {{ secondaryText }}
      </button>
    }
    <div class="footer-actions">
      @if (showCancel) {
        <button
          type="button"
          class="secondary-btn"
          [class.desktop-only]="cancelDesktopOnly"
          (click)="cancelClick.emit()"
          [disabled]="cancelDisabled"
        >
          {{ cancelText }}
        </button>
      }
      @if (showPrimary) {
        <button
          type="button"
          class="apply-btn"
          (click)="primaryClick.emit()"
          [ngClass]="primaryExtraClass"
          [disabled]="primaryDisabled"
        >
          @if (primaryLoading) {
            <span>{{ primaryLoadingText }}</span>
          } @else {
            <span>{{ primaryText }}</span>
          }
        </button>
      }
    </div>
  } @else {
    <!-- Shared `.modal-footer` design (source of truth) -->
    @if (showSecondary) {
      <button
        type="button"
        class="btn btn-tertiary btn-medium"
        [class.desktop-only]="secondaryDesktopOnly"
        [class.disabled]="secondaryDisabled"
        [disabled]="secondaryDisabled"
        (click)="secondaryClick.emit()"
      >
        {{ secondaryText }}
      </button>
    }
    <div class="actions">
      @if (showCancel) {
        <button
          type="button"
          class="btn btn-secondary btn-medium"
          [class.desktop-only]="cancelDesktopOnly"
          (click)="cancelClick.emit()"
          [disabled]="cancelDisabled"
        >
          {{ cancelText }}
        </button>
      }
      @if (showPrimary) {
        <button
          [attr.type]="primaryButtonType"
          class="btn btn-primary btn-medium"
          (click)="onPrimaryClick()"
          [ngClass]="primaryExtraClass"
          [disabled]="primaryDisabled"
        >
          @if (primaryLoading) {
            <span class="modal-footer-loading">
              <span class="modal-footer-spinner" aria-hidden="true"></span>
              <span>{{ primaryLoadingText }}</span>
            </span>
          } @else {
            <span>{{ primaryText }}</span>
          }
        </button>
      }
    </div>
  }
</div>
